import React, { useEffect, createElement } from 'react';
import { CountdownBanner } from './components/CountdownBanner';
import { HeroSection } from './components/HeroSection';
import { SalesContent } from './components/SalesContent';
import { FeaturesSection } from './components/FeaturesSection';
import { MethodSection } from './components/MethodSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window.fbq === 'function') return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    window.fbq('init', '1696803758360039');
    window.fbq('track', 'PageView');
    // noscript fallback image
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1696803758360039&ev=PageView&noscript=1';
    document.body.appendChild(img);
  }, []);
  return <div className="min-h-screen bg-brand-cream-light font-sans selection:bg-brand-orange/30 selection:text-brand-navy" data-id="element-0">
      <CountdownBanner data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SalesContent data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <MethodSection data-id="element-6" />
        <FAQSection data-id="element-7" />
        <PricingSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}